import { Component } from "@theme/component";
import { ThemeEvents } from "@theme/events";

/**
 * Varianten-Auswahl mit Farbkreisen und Chips.
 *
 * Schaltet nicht selbst die Variante, sondern klickt das passende Radio-Feld im
 * Varianten-Picker des Themes. Dadurch aktualisiert das Theme Preis, Adresszeile,
 * Bildergalerie und Verfügbarkeit wie gewohnt — hier muss nichts nachgebaut werden.
 */
class VarianteAuswahl extends Component {
  connectedCallback() {
    super.connectedCallback();

    this.sectionId = this.dataset.sectionId;

    this.onVariantUpdate = () => this.#ausPickerUebernehmen();
    document.addEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);

    this.#themePickerAusblenden();
    this.#ausPickerUebernehmen();
  }

  disconnectedCallback() {
    super.disconnectedCallback?.();
    document.removeEventListener(ThemeEvents.variantUpdate, this.onVariantUpdate);
  }

  get #section() {
    return document.getElementById(`shopify-section-${this.sectionId}`) || document;
  }

  /** Alle Radio-Felder des Theme-Pickers, nach Optionsposition gruppiert. */
  #radios(position) {
    const alle = Array.from(this.#section.querySelectorAll('input[type="radio"][data-input-id]'));
    return alle.filter((r) => r.dataset.inputId?.startsWith(`${position}-`));
  }

  /**
   * Blendet den Picker des Themes aus — die Auswahl passiert hier. Er bleibt im
   * DOM, weil seine Radio-Felder weiterhin geklickt werden.
   */
  #themePickerAusblenden() {
    this.#section.querySelectorAll(".variant-option").forEach((gruppe) => {
      gruppe.classList.add("vauswahl-ausgeblendet");
    });
  }

  /* -------------------------------------------------------- Ereignisse */

  wertWaehlen(event) {
    // event.target, nicht currentTarget — das Theme reicht Handler über einen
    // globalen Listener nach (assets/component.js).
    const knopf = event.target.closest("[data-wert]");
    if (!knopf) return;

    const position = parseInt(knopf.dataset.option, 10);
    const wert = knopf.dataset.wert;

    const ziel = this.#radios(position).find((r) => r.value === wert);
    if (!ziel) return;
    if (!ziel.checked) ziel.click();

    // Sofort spiegeln; nach dem Neurendern korrigiert #ausPickerUebernehmen.
    this.#markieren(position, wert);
  }

  /** Übernimmt den Stand des Theme-Pickers — z. B. nach einem Variantenwechsel. */
  #ausPickerUebernehmen() {
    for (const gruppe of this.querySelectorAll(".vauswahl__gruppe")) {
      const position = parseInt(gruppe.dataset.option, 10);
      const aktiv = this.#radios(position).find((r) => r.checked);
      if (aktiv) this.#markieren(position, aktiv.value);
    }
  }

  #markieren(position, wert) {
    for (const knopf of this.querySelectorAll(`[data-wert][data-option="${position}"]`)) {
      const gewaehlt = knopf.dataset.wert === wert;
      knopf.classList.toggle("is-gewaehlt", gewaehlt);
      knopf.setAttribute("aria-checked", gewaehlt ? "true" : "false");
    }

    const anzeige = this.querySelector(`.vauswahl__wert[data-option="${position}"]`);
    if (anzeige) anzeige.textContent = wert;
  }
}

if (!customElements.get("variante-auswahl")) {
  customElements.define("variante-auswahl", VarianteAuswahl);
}
